import MuiDivider from "components/Divider";
import Stack from "components/Stack";

import ColumnRows from "./ColumnRows";

export interface ITransactionCollapseTitlesRow {
  isHeading: boolean;
}

const TransactionCollapseTitlesRow = ({
  isHeading,
}: ITransactionCollapseTitlesRow) =>
  isHeading ? (
    <>
      <ColumnRows />
      <MuiDivider sx={{ gridColumn: "1 / -1" }} />
    </>
  ) : (
    <Stack
      display="grid"
      gridTemplateColumns="50px 0.7fr 1fr 1fr 0.7fr 1fr 1fr 100px 35px"
      gap={1}
    >
      <ColumnRows />
      <MuiDivider sx={{ gridColumn: "1 / -1" }} />
    </Stack>
  );

export default TransactionCollapseTitlesRow;
